<template lang="pug">
v-dialog(v-model='isOpen' max-width='600px' persistent scrollable)
  v-card
    v-card-title
      div(class='headline') Копирование структуры
    v-card-text
        div(v-if='inSection>0' class="comment")  в {{inSection}} подъезде
        div(v-else class="comment") со всех подъездов
    v-card-text(style='height: 300px' class="pt-0")
      v-divider
      v-row
        v-radio-group(v-model='selectedSource' class="mt-0 pt-0")
          v-radio(
            class="mt-2"
            v-for='source in sources',
            :key='source.id',
            :value='source.id',
            :label='source.name',
            color='primary'
          )
    v-card-actions
      v-spacer
      v-btn(flat @click="$emit('undo')") Отмена
      v-btn(
        flat,
        color="primary",
        @click="copyStruct",
        :disabled="selectedSource===null"
      ) Скопировать
</template>

<script>
import http from '@/http'
export default {
  props: ['floorId', 'isOpen','inSection'],
  data: () => ({
    sources: [],
    selectedSource: null
  }),
  mounted() {
      this.fetchSources()
  },
  methods: {
    fetchSources() {
      const query = http.get(`/complexes/floors/${this.floorId}/donors?currentSection=${this.inSection}`)
      query.then(res => this.sources = res.data)
    },
    copyStruct() {
      if (this.selectedSource !== null) {
        const donorId = this.selectedSource
        const query = http.get(`/complexes/floors/donors/${donorId}`)
        query.then(res => this.$emit('copySuccess', res.data))
      }
    }
  }
}
</script>

<style scoped>
.comment {
  margin-bottom: 0px;
  font-size: 16px;
}
</style>